export const APIEndpoints = {
  NHCAPI: {
    name: "PlatformCore",
    endpoint: process.env.REACT_APP_NHC_CORE_API_ENDPOINT,
  },
  NHCSERVICEAPI: {
    name: "PlatformServices",
    endpoint: process.env.REACT_APP_NHC_SERVICES_API_ENDPOINT,
  },
  NHCCOMMONSERVICEAPI: {
    name: "CommonServices",
    endpoint: process.env.REACT_APP_NHC_COMMON_API_ENDPOINT,
  },
  NHCCLINICAPI: {
    name: "ClinicServices",
    endpoint: process.env.REACT_APP_NHC_CLINIC_API_ENDPOINT,
  },
  NHCUSERAPI: {
    name: "UserServices",
    endpoint: process.env.REACT_APP_NHC_USER_API_ENDPOINT,
  },
  NHCCLINICCOREAPI: {
    name: "ClinicCoreServices",
    endpoint: process.env.REACT_APP_NHC_CLINIC_CORE_API_ENDPOINT,
  },
  NHCPATIENT360API: {
    name: "Patient360Details",
    endpoint: process.env.REACT_APP_NHC_PATIENT_360_API_ENDPOINT,
  },
  NHCUSERACCESSAPI: {
    name: "UserAccessRoles",
    endpoint: process.env.REACT_APP_NHC_USER_ACCESS_API_ENDPOINT,
  },
  NHCNLPAPI: {
    name: "NLPServices",
    endpoint: process.env.REACT_APP_NHC_NLP_DEV_ENDPOINT
  },
  NHCBOTMANAGEMENTAPI:{
    name: "BOTManagemnet",
    endpoint: process.env.REACT_APP_NHC_BOT_MANAGEMENT_ENDPOINT
  }
};

export const APIPaths = {
  SIGNUP: "/signup",
  GET_BOT_LIST: "/bot",
  GET_USER_PROFILE: "/profile",
  LEAD_GENERATION: "/lead",
  PLATFORM_SERVICES: "/services",
  PLATFORM_SERVICES_SUBSCRIBED: "/subscription",
  ADD_NEW_PLATFORM_SERVICE: "/add-subscription",
  UPDATE_PLATFORM_SERVICE_DETAILS: (id) => `/subscription/${id}`,
  CONTACT_US: "/contact_us",
  ADT_PATIENT: (followUpDays) => `/patient/followup?day=${followUpDays}`,
  ADT_PATIENT_FOLLOWUP: (ADTId) => `/followup?adt_id=${ADTId}`, 
  ADT_ADD_PATIENT_FOLLOWUP: "/followup",
  ADT_FILES_PROCESSED: "/patient/import/status?status=COMPLETED",
  ADT_FILE_UPLOAD: "/upload?type=ADT_BOT_FILE",
  USER_CLINICS: "/clinics",
  DASHBOARD_URL: (child_resource, dashboardName) => `/clinic/dashboard?child_resource=${child_resource}&name=${dashboardName}`,
  IMPORT_FILE_URL:"/clinic/data/upload/url",
  IMPORT_HISTORY_LIST:"/clinic/data/upload",
  DASHBOARD_LIST: "/clinic/dashboards",
  USER_PROFILE_PIC: "/user/profile_picture",
  USER_DETAILS: "/user/details",
  PAYERS_DETAILS: "/payer",
  PAYER_MEASURE_DETAILS: "/payer/measure",
  MEASURE_DETAILS: (payerId) => `/payer/${payerId}/measure`,
  UPDATE_MEASURES_DETAILS: (payerId) => `/payer/${payerId}/measure`,
  SUPPORT_CATEGORY: "/category",
  SUPPORT_REQUEST_LIST: "/support-request",
  SEARCH_REQUEST: "/search",
  ANNOUNCEMENT: "/announcement",
  CLINIC_LOCATION: "/location",
  CLINIC_LOCATION_UPDATE: (locationId) => `/location/${locationId}`,
  USER_INVITATION_DETAILS: "/invitation",
  USER_INVITATION_UPDATE: (invitationId) =>  `/invitation/${invitationId}`,
  USER_INVITATION_RESEND: (invitationId) =>  `/invitation/${invitationId}/invite`,
  USER_METRICS: "/metrics",
  USER_LIST: "/users",
  USER_EDIT: (email) => `/users/${email}`,
  CLINIC_LOGO_UPDATE: "/clinic/logo",
  METRICS: "/patient/metrics",
  BASIC_PATIENT_DETAILS: "/patient",
  PATIENT_HISTORY_DETAILS: "/patient/history",
  PATIENT_TREATMENT_DETAILS: "/patient/treatment",
  PATIENT_OTHER_DETAILS: (patient_account_number) =>  `/patient/${patient_account_number}/details`,
  PATIENT_FILTER_VALUES: "/patient/filters",
  PATIENT_FILTER_META_DATA: "/patient/query_metadata",
  PATIENT_FILTER_LOOK_UP_VALUES: "/patient/lookup_data",
  PATIENT_TRIAL_REPORT: "/patient/search-patient-data",
  PATIENT_TRIAL_REPORT_EXPORT:"/patient/export",
  VIEW_DETAILS: "/view",
  UPDATE_VIEW_DETAILS: (id) =>`/view/update/${id}`,
  DELETE_VIEW: (id) => `/view/${id}`,
  EXPORT_VIEW: "/patient/download",
  ACCESS_ROLE: "/roles/custom",
  ACCESS_ROLE_DETAILED: "/roles/custom/detailed",
  ACCESS_ROLE_OPERATION: (id) => `/roles/custom/${id}`,
  CLINIC_BASED_PERMISSIONS: "/permissions",
  AUDIO_TO_TEXT: "/text",
  AUDIO_TO_DATA: "/data/audio",
  TEXT_TO_DATA: "/data/text",
  FEEDBACK: "/feedback",
  BOT_CREATION: "/create",
  BOT_CONFIGURATION: "/configuration"
};
// TODO: To be deleted, kept only of ref during code changes
//DASHBOARD_URL: (clinicId, dashboardName) => `/clinic/${clinicId}/dashboard?name=${dashboardName}`,

